import * as React from "react";
import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isLoading: boolean;
};

const SkeletonLoading = React.memo(
  ({ isLoading, children, ...props }: Props) => {
    return isLoading ? <Skeleton {...props} /> : children;
  },
);
SkeletonLoading.displayName = "SkeletonLoading";

export { Skeleton, SkeletonLoading };
